import React from 'react';
import { Drawer } from 'antd';
import { CONSTANT } from '../../../../config/Constant';
import ExportCSVReport from '../../../../components/ExportCSVReport';

const ViewReport: React.FC<any> = (props) => {
  const { handleViewReport, openUpdateModal, openUpdateData } = props;

  const viewData = openUpdateData?.response ? JSON.parse(openUpdateData?.response) : null;
  //console.log('viewData', viewData);
  //console.log('openUpdateData', openUpdateData?.type);

  const monthlyData = (data) => {
    return (
      <>
        <thead>
          <tr>
            <th>Provider</th>
            <th>Number of Publish</th>
            <th>Month</th>
          </tr>
        </thead>
        <tbody>
          {data?.length > 0 ? (
            data.map((item: any, index: number) => {
              return (
                <tr key={index}>
                  <td>{item.provider}</td>
                  <td>{item.number_of_publish}</td>
                  <td>{item.month}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={3}>{CONSTANT.NO_DATA_FOUND}</td>
            </tr>
          )}
        </tbody>
      </>
    );
  };

  const weeklyData = (data) => {
    return (
      <>
        <thead>
          <tr>
            <th>Provider</th>
            <th>Number of Publish</th>
            <th>Week Date</th>
            <th>Calendar Week</th>
          </tr>
        </thead>
        <tbody>
          {data?.length > 0 ? (
            data.map((item: any, index: number) => {
              return (
                <tr key={index}>
                  <td>{item.provider}</td>
                  <td>{item.number_of_publish}</td>
                  <td>{item.week_date}</td>
                  <td>{item.calendar_week}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={4}>{CONSTANT.NO_DATA_FOUND}</td>
            </tr>
          )}
        </tbody>
      </>
    );
  };

  const dailyData = (data) => {
    return (
      <>
        <thead>
          <tr>
            <th>Provider</th>
            <th>Number of Publish</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {data?.length > 0 ? (
            data.map((item: any, index: number) => {
              return (
                <tr key={index}>
                  <td>{item.provider}</td>
                  <td>{item.number_of_publish}</td>
                  <td>{item.day}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={3}>{CONSTANT.NO_DATA_FOUND}</td>
            </tr>
          )}
        </tbody>
      </>
    );
  };

  return (
    <Drawer
      open={openUpdateModal}
      destroyOnClose
      width={900}
      onClose={handleViewReport}
      footer={
        viewData ? <div className="text-right">
          <ExportCSVReport
            elements={viewData}
            reportName={`publish-${openUpdateData.type}-${Date.now()}`}
            label={true}
          />
        </div> : false
      }
      className="addModal"
      title={`View Report`}
    >
      <table
        className="reportTable"
        width={'100%'}
      >
        {openUpdateData?.type === 'monthly'
          ? monthlyData(viewData)
          : openUpdateData?.type === 'weekly'
            ? weeklyData(viewData)
            : dailyData(viewData)}
      </table>
      {/* {viewData?.length > 0 ? viewData.map((item: any) => monthlyData(item)) : null} */}
    </Drawer>
  );
};

export default ViewReport;
